/**
 * Transactiedata voor het buurtlab (MA-55): een uitdraai van een makelaar
 * (Realworks-export), omgezet naar één JSON-bestand.
 *
 * Dit is vertrouwelijke makelaarsdata. Hij staat daarom niet in git en niet in
 * `apps/web/public`, maar als bestand op de server buiten de code-map; de API
 * geeft hem achter de login door via GET /api/v1/buurtlab/transacties.
 *
 * Velden die de export (nog) leeg laat zijn `null`, nooit 0: een lege
 * transactieprijs betekent "nog niet verkocht of niet bekend", niet "gratis".
 */
import { z } from 'zod';

const getalOfNull = z.number().nullable();
const tekstOfNull = z.string().nullable();

export const transactieSchema = z.object({
  buurt: z.string(),
  adres: z.string(),
  postcode: tekstOfNull,
  /** Zoals de makelaar hem noemt: "Beschikbaar", "Onder bod", "Verkocht onder voorbehoud" ... */
  status: z.string(),
  /** Vraagprijs in euro. */
  prijs: getalOfNull,
  /** Woonoppervlakte in m². */
  m2: getalOfNull,
  prijsPerM2: getalOfNull,
  transactieprijs: getalOfNull,
  /** ISO-datum (jjjj-mm-dd). */
  aanmelding: tekstOfNull,
  transactiedatum: tekstOfNull,
  /** Dagen in de verkoop. */
  dagen: getalOfNull,
  /** "Appartement" of "Woonhuis". */
  soort: tekstOfNull,
  bouwjaar: getalOfNull,
});
export type Transactie = z.infer<typeof transactieSchema>;

export const buurtlabTransactiesSchema = z.object({
  /** Waar de uitdraai vandaan komt, in één regel. */
  bron: z.string(),
  woningen: z.array(transactieSchema),
});
export type BuurtlabTransacties = z.infer<typeof buurtlabTransactiesSchema>;
